import React from 'react';
import {ParcelasDTO} from '../../../../../../../dtos/ParcelasDTO';
import {
  CheckoutBrand,
  CheckoutIcon,
  Container,
  ProductValueContainer,
  Section,
  Value,
  ValueContainer,
  ValueDescription,
  ValueGroup,
} from './styles';

type Props = {
  totalValue: number;
  installment: ParcelasDTO | null;
  numero_parcela: number;
  data_vencimento: string;
};

function formatDate(dateStr: string): string {
  const parts = dateStr.split('T')[0].split('-');
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function EmprestimoHeader({totalValue, installment, numero_parcela, data_vencimento}: Props) {
  const formatMoeda = (value: number) =>
    value.toLocaleString('pt-BR', {currency: 'BRL', style: 'currency'});

  return (
    <Container>
      <Section>
        <ProductValueContainer>
          <ValueContainer>
            <Value>
              {installment
                ? `${installment.installmentCount}x ${formatMoeda(installment.valorMes)}`
                : formatMoeda(totalValue)}
            </Value>
            <ValueGroup>
              <ValueDescription>
                Parcela {numero_parcela} · Venc. {formatDate(data_vencimento)}
              </ValueDescription>
            </ValueGroup>
          </ValueContainer>
          <CheckoutBrand>
            <CheckoutIcon name="hand-holding-usd" />
          </CheckoutBrand>
        </ProductValueContainer>
      </Section>
    </Container>
  );
}
